<span (click)="toggleHighlightHome()" *ngIf="highlightHome" class="list-item__action list-item__action--secondary">Tirar Destaque Home</span>
<span (click)="toggleHighlightHome()" *ngIf="!highlightHome" class="list-item__action list-item__action--secondary">Destacar Home</span>

<span (click)="toggleHighlightNews()" *ngIf="highlightNews" class="list-item__action list-item__action--secondary">Tirar Destaque News</span>
<span (click)="toggleHighlightNews()" *ngIf="!highlightNews" class="list-item__action list-item__action--secondary">Destacar News</span>
